<template>
  <simple-page>
    <template #pageItem>
      <breadcrumb :items="breadcrumbItems" />
    </template>
    <template #pageTitle>
      <div class="titleBtn">
        <h1>Manage Menu</h1>
      </div>
    </template>
    <template #topPagination>
      <div class="filter-field text-end mb-3">
        <input
          type="text"
          placeholder="Search (by menu name)"
          class="custom-input"
          @keyup="filterMenu"
          v-model="filters.query"
        />
      </div>
    </template>
    <template #table>
      <menu-list :rows="menuList" @onManage="getMenuDetails" />
      <menu-form
        :row.sync="row"
        @onSuccess="getMenuList(filters)"
      />
      <pagination :rows.sync="menuList" />
    </template>
  </simple-page>
</template>

<script>
import Api from "@/resource/Api";
import helper from "@/resource/Helper";
import MenuForm from "./partials/MenuForm.vue";
import MenuList from "./partials/MenuList.vue";

export default {
  components: {
    MenuForm,
    MenuList,
  },
  data: () => ({
    breadcrumbItems: [{ title: "Manage Menu", active: true }],
    menuList: [],
    row: null,
    filters: {
      query: "",
    },
  }),
  methods: {
    openForm() {
      this.$bvModal.show("manageMenu");
    },
    getMenuList(filters = null) {
      let loader = !filters ? this.$loading.show() : "";
      let url = "v2/rep/get-paginated-menu";
      if (filters) {
        let filterUrl = helper.objToUrlParams(filters);
        url = `${url}?${filterUrl}`;
        if (this.rows && this.rows.current_page) {
          url = url + `&page=${this.rows.current_page}`;
        }
      }
      Api.get(url)
        .then((res) => {
          this.menuList = res.data;
        })
        .catch(() => {
          this.menuList = [];
        })
        .finally(() => {
          loader ? loader.hide() : "";
        });
    },
    filterMenu() {
      this.getMenuList(this.filters);
    },
    getMenuDetails(row){
      let loader = this.$loading.show();
      Api.get(`v2/rep/${row.id}/menu-detail`).then((res)=>{
        this.row = res.data.data;
      })
      .catch(()=>{
        this.row = {};
      })
      .finally(()=>{
        loader.hide();
        this.openForm();
      })
    }
  },
  created() {
    this.getMenuList();
    this.$store.commit("setSendRepMessageSelectedReps", []);
  },
};
</script>

<style >
.filter-field .custom-input {
  max-width: 300px;
}
.custom-input {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
  box-shadow: none !important;
}
.donwlinedata-card > table > strong {
  padding: 0;
}
</style>
